import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import useDash from "../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../assets/js/theme";
import Footer from "../../components/admin/footer/Footer";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import {
  ArchiveFill,
  ArrowClockwise,
  PenFill,
  PersonPlusFill,
  ThreeDots,
} from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../components/table/Table";
import SupportNumberPost from "./customerSupport/SupportNumberPost";
import {
  deleteIspOwnerSupporterNumber,
  getIspOwnerSupportNumbers,
} from "../../features/apiCalls";
import SupportNumberEdit from "./customerSupport/SupportNumberEdit";
import moment from "moment";
import Loader from "../../components/common/Loader";

const SupportNumbers = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // netFee support data
  const ispOwnerSupportNumbers = useSelector(
    (state) => state.netFeeSupport?.ispOwnerSupport,
  );

  //get isp owner id
  const ispOwner = useSelector(
    (state) => state.persistedReducer.auth?.ispOwnerId,
  );

  //---> Local States
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState("");
  const [show, setShow] = useState(false);
  const [supportId, setSupportId] = useState("");

  // support number update handler
  const numberEditHandler = (id) => {
    setSupportId(id);
    setModalState("update");
    setShow(true);
  };

  // support number delete handler
  const supportDeleteHandler = (supportId) => {
    let confirm = window.confirm(t("antToDeleteSupport"));
    if (confirm) {
      deleteIspOwnerSupporterNumber(dispatch, ispOwner, supportId);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        width: "16%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        Header: t("name"),
        width: "16%",
        accessor: "name",
      },
      {
        Header: t("mobile"),
        width: "20%",
        accessor: "mobile",
      },
      {
        width: "16%",
        Header: t("startTime"),
        accessor: "start",
        Cell: ({ cell: { value } }) => moment(value).format("LT"),
      },
      {
        width: "16%",
        Header: t("endTime"),
        accessor: "end",
        Cell: ({ cell: { value } }) => moment(value).format("LT"),
      },

      {
        width: "16%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",

        Cell: ({ row: { original } }) => (
          <div className="d-flex align-items-center justify-content-center">
            <div className="dropdown">
              <ThreeDots
                className="dropdown-toggle ActionDots"
                id="areaDropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu" aria-labelledby="customerDrop">
                <li
                  data-bs-toggle="modal"
                  data-bs-target="#supportEdit"
                  onClick={() => numberEditHandler(original.id)}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PenFill />
                      <p className="actionP">{t("edit")}</p>
                    </div>
                  </div>
                </li>

                <li
                  data-bs-toggle="modal"
                  data-bs-target="#supportDelete"
                  onClick={() => supportDeleteHandler(original.id)}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <ArchiveFill />
                      <p className="actionP">{t("delete")}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ),
      },
    ],
    [t],
  );

  useEffect(() => {
    if (ispOwnerSupportNumbers.length === 0)
      getIspOwnerSupportNumbers(dispatch, ispOwner, setIsLoading);
  }, []);

  const reloadHandler = () => {
    getIspOwnerSupportNumbers(dispatch, ispOwner, setIsLoading);
  };

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div>{t("supportNumbers")}</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <PersonPlusFill
                      className="addcutmButton"
                      title={t("addSupportTicket")}
                      onClick={() => {
                        setModalState("create");
                        setShow(true);
                      }}
                    />

                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        ></ArrowClockwise>
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>
              <FourGround>
                <div className="collectorWrapper mt-2 py-2">
                  <Table
                    isLoading={isLoading}
                    columns={columns}
                    data={ispOwnerSupportNumbers}
                  ></Table>
                </div>
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>

      {/* Customer support number create modal */}
      {modalState === "create" && (
        <SupportNumberPost show={show} setShow={setShow} />
      )}

      {/* Customer support number update modal */}
      {modalState === "update" && (
        <SupportNumberEdit
          supportId={supportId}
          editShow={show}
          setEditShow={setShow}
        />
      )}
    </>
  );
};

export default SupportNumbers;
